import React, { ReactNode } from 'react';

import {
  CardContainer,
  Header,
  Title,
  HeaderAction,
  Body,
  ItemsGrid,
  Item,
  ItemLabel,
  ItemValue,
  ItemHelper,
  CardFooter,
} from './styled';
import { InfoItem } from '../InfoItem/InfoItem';
import { EnrollmentItem } from '../EnrollmentItem/EnrollmentItem';

export type EnrollmentCardItem = {
  id?: string | number;
  label?: ReactNode;
  value?: ReactNode;
  helperText?: ReactNode;
  component?: ReactNode;
  hideValue?: boolean;
};

export type EnrollmentCardProps = {
  title?: ReactNode;
  action?: ReactNode;
  items?: EnrollmentCardItem[];
  hideHeader?: boolean;
  columns?: number;
  footer?: ReactNode;
  className?: string;
};

export default function EnrollmentCard({
  title,
  action,
  items = [],
  hideHeader = false,
  columns = 2,
  footer,
  className,
}: EnrollmentCardProps) {
  const hasHeaderContent = !hideHeader && (!!title || !!action);
  const gridColumns = Math.max(1, Math.floor(columns || 1));
  const filteredItems = items.filter((item): item is EnrollmentCardItem => Boolean(item));

  return (
    <CardContainer className={className}>
      {hasHeaderContent && (
        <Header>
          {title && <Title>{title}</Title>}
          {action && <HeaderAction>{action}</HeaderAction>}
        </Header>
      )}

      {filteredItems.length > 0 && (
        <Body hasHeader={hasHeaderContent}>
          <ItemsGrid columns={gridColumns}>
            {filteredItems.length > 0 &&
              filteredItems.map((item, index) => {
                const key = item?.id ?? `${index}-${item?.label ?? 'item'}`;

                return item.component ? (
                  item.component
                ) : (
                  <EnrollmentItem
                    key={key}
                    title={item.label}
                    value={item.value}
                    fullWidth
                    hideValue={item.hideValue}
                  />
                );
              })}
          </ItemsGrid>
        </Body>
      )}

      {footer && <CardFooter>{footer}</CardFooter>}
    </CardContainer>
  );
}
